// Add to lib/utils/dateFormat.ts or create a new file lib/utils/apiDateFormat.ts
import { format, parseISO } from 'date-fns';

/**
 * Format a date for API requests
 * @param date The date to format
 * @param formatString The format string (default: 'yyyy-MM-dd')
 */
export function formatDateForApi(date: Date | string | number | null | undefined, formatString: string = 'yyyy-MM-dd'): string {
  if (!date) {
    return '';
  }
  
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    return format(dateObj, formatString);
  } catch (error) {
    console.error('Error formatting date for API:', error);
    return '';
  }
}

/**
 * Parse a date string from API
 * @param dateString The date string to parse
 */
export function parseDateFromApi(dateString: string | null | undefined): Date | null {
  if (!dateString) {
    return null;
  }
  
  try {
    return parseISO(dateString);
  } catch (error) {
    console.error('Error parsing date from API:', error);
    return null;
  }
}